export default __webpack_public_path__ + "static/media/sample-img.601b9257.png";